import { useState } from 'react';
import { locationIsKia } from '../../../utils/helpers';
import { AppProps } from '../../App';
import { useModule } from '../../hooks/useModule';
import Toolbar from '../components/toolbar';
import ModulePageBuilder from '../module-pagebuilder';
import ModuleSlugSelector from './module-slug-selector';

export default function RenderWpModule({ uri }: Pick<AppProps, 'uri'>) {
  const queryString =
    typeof window !== 'undefined' ? window.location.search : '';
  const searchParams = new URLSearchParams(queryString);
  const pageParam = searchParams.get('wp');

  const [selectedSlug, setSelectedSlug] = useState<string | null>(pageParam);

  const handleSelectSlug = (slug: string | null) => {
    setSelectedSlug(slug);
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      if (slug) {
        params.set('wp', slug);
      } else {
        params.delete('wp');
      }
      window.history.replaceState(null, '', `?${params.toString()}`);
    }
  };

  const [isPreviewMode, setPreviewMode] = useState<boolean>(
    !locationIsKia() || !!pageParam,
  );

  const handleRefetch = () => {
    refetch();
  };

  const activeSlug = uri || selectedSlug || pageParam;

  const { data, isLoading, isError, error, refetch, isRefetching } = useModule(
    activeSlug || '',
    isPreviewMode,
  );

  if (!activeSlug && !locationIsKia()) {
    return (
      <div className="mx-auto max-w-lg">
        <h2 className="mb-4 text-xl font-bold">Välj en modul</h2>
        <ModuleSlugSelector onSelect={handleSelectSlug} />
      </div>
    );
  }

  if (isLoading && !locationIsKia())
    return <div className="p-4">Loading...</div>;

  if (isError) {
    console.error(error);
    if (locationIsKia() && isPreviewMode === false) {
      setPreviewMode(true);
    }
    return (
      <div className="p-8 text-red-600">
        <h2 className="font-bold">Error Loading Module</h2>
        <p>{error instanceof Error ? error.message : 'Unknown Error'}</p>

        {!locationIsKia() ||
          (!isPreviewMode && (
            <>
              <p className="text-black">
                Det kan vara så att denna modulen inte är publicerad och att det
                är därför du inte kan se <span className="font-bold">Live</span>{' '}
                versionen.
              </p>
              <button
                onClick={() => setPreviewMode(true)}
                className="mt-4 bg-blue-500 text-white px-4 py-2 rounded"
              >
                Preview
              </button>
            </>
          ))}
      </div>
    );
  }

  return (
    <>
      {Boolean(uri) ||
        (!locationIsKia() ? (
          <Toolbar
            isPreviewMode={isPreviewMode}
            setPreviewMode={setPreviewMode}
            databaseId={
              data.kiaModule.databaseId ? data.kiaModule.databaseId : undefined
            }
            refetch={handleRefetch}
            isRefetching={isRefetching}
            uri={activeSlug}
            page="module"
          >
            <ModuleSlugSelector
              selected={selectedSlug}
              onSelect={handleSelectSlug}
            />
          </Toolbar>
        ) : null)}

      <ModulePageBuilder blocks={data?.kiaModule?.pagebuilder?.blocks} />
    </>
  );
}
